import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LayoutHelper } from '../../../helpers/layout.helper';
import { MetaHelper } from '../../../helpers/meta.helper';
import { LayoutService } from '../../../services/layout.service';
import { APropertyTab } from '../properties/properties.menu.tab';
import { NavigationService } from '../../../services/navigation.service';

@Component({
    selector: 'output-menu-tab',
    templateUrl: './output.menu.tab.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OutputMenuTab extends APropertyTab {

    //get DataSource() {
    //    if (this.TableProperties && this.TableProperties.Fields) {
    //        return this.TableProperties.Fields.find(x => x.ID === this.SelectedItemValue.OutputStyle);
    //    }
    //    return null;
    //}
    //_DataSource;
    //set DataSource(val) {
    //    this._DataSource = val;

    //}
    //DataSourceChanged() {
    //    let val = this._DataSource;
    //    if (val) {
    //        if (this.SelectedItemValue.OutputStyle != val.ID) {
    //            this.SelectedItemValue.OutputStyle = val.ID;
    //            this.onStyleChanged(['OutputStyle']);
    //        }
    //    } else {
    //        if (this.SelectedItemValue.OutputStyle != null) {
    //            this.SelectedItemValue.OutputStyle = null;
    //            this.onStyleChanged(['OutputStyle']);
    //        }
    //    }
    //    LayoutService.LayoutChanged.next(null);
    //}
    //TableProperties;
    //Layout;

    static CheckOnChange(menuItem: any) {
        menuItem.Visible = false;
        if (NavigationService.SelectedPage.getValue() == 'output') {
            const selected = LayoutService.SelectedItem.getValue();
            if (selected) {
                menuItem.Visible = selected.ElementType == 'grid' || selected.ElementType == 'canvas' || selected.ElementType == 'repeat';
                //const layout = LayoutHelper.GetLayout();
                //const resolution = LayoutHelper.GetActiveResolution(layout);
                //OutputMenuTab.GetTableProperties(resolution, selected).then((x) => {
                //    if (x) {
                //        menuItem.Visible = true;
                //        LayoutHelper.RefreshMenuTabs.next(null);
                //    }
                //});
            }
        }
    }

    //private static GetTableProperties(layout, selected) {
    //    return new Promise(resolve => {
    //        if (layout && selected && layout !== selected) {
    //            MetaHelper.FindTableProperties(layout, selected).then((result) => {
    //                if (result && result.Fields) {
    //                    const retVal = JSON.parse(JSON.stringify(result));
    //                    retVal.Fields = retVal.Fields.filter(element => element.Type == '944c8a5c-a09f-419d-94fd-28344e52bf0f');
    //                    if (retVal.Fields.length > 0) {
    //                        resolve(retVal);
    //                    } else {
    //                        resolve(null);
    //                    }
    //                } else {
    //                    resolve(null);
    //                }
    //            });
    //        } else {
    //            resolve(null);
    //        }
    //    });
    //}

    //ngOnInit(): void {
    //    super.ngOnInit();
    //    this.Subscriptions.push(LayoutService.SelectedLayout.subscribe((layout) => {
    //        this.Layout = layout;
    //        this.ReadTableProperties();
    //    }));
    //}

    //onItemSet() {
    //    this.ReadTableProperties();
    //}

    //ReadTableProperties() {
    //    this.TableProperties = null;
    //    const layout = this.Layout;
    //    const resolution = LayoutHelper.GetActiveResolution(layout);
    //    OutputMenuTab.GetTableProperties(resolution, this.SelectedItemValue).then((x) => {
    //        this.TableProperties = x;
    //        this.cdRef.detectChanges();
    //    });
    //}
}
